import {
    addResponsibility,
    editResponsibility,
    deleteResponsibility
} from "./actions";


export default {
    "label": "Technical Secretary Responsibilities",
    "key": "TechnicalSecretaryResponsibilities",
    "location": "Database/TechnicalSecretaryResponsibilities/",
    "headers": [{
        "headerName": "Responsibility",
        "field": "Responsibility"
    }, {
        "headerName": "Colours",
        "field": "Colours"
    }],
    "actions": [{
        "label": "Add Responsibility",
        "action": addResponsibility
    }],
    "rowActions": [{
        "label": "Edit Responsibility",
        "action": editResponsibility
    }, {
        "label": "Delete Responsibility",
        "action": deleteResponsibility
    }]
}
